export class Usuario {
    id: number;
    orgaoid: string;
    nome: string;
    cpfcnpj: string;
    email: string;
    ​​celular: string;
    ​​tipo: string;
    ​​origem: string;
    ​​senha: string;
    ​​status: string;
    aceitetermo: Date;
    dtreg: Date;
    dtupd: Date;
    ​​saldo: number;
}
